import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import http from '../utils/http';
import { RootState, store } from './store';


export interface affiliateState {
    test: string;
    selectedAffiliatedEntityCode: string;
    status: 'idle' | 'loading' | 'failed';
}

const initialState: affiliateState = {
    test: "",
    selectedAffiliatedEntityCode : "",
    status: "idle"
}

export const affiliateSlice = createSlice({
    name: 'affiliate',
    initialState,
    reducers: {
        setSelectedAffiliatedEntityCode: (state: any, action: any) => {
            state.selectedAffiliatedEntityCode = action.payload;
        },
        setTestCode: (state: any, action: any) => {
            state.test = action.payload;
            state.selectedAffiliatedEntityCode = state.test;
        }
    },
    extraReducers: (builder: any) => {
    },
});

export const { setSelectedAffiliatedEntityCode, setTestCode } = affiliateSlice.actions;

export const getSelectedAffiliateEntityCode = (state: RootState) => state.affiliate ? state.affiliate.selectedAffiliatedEntityCode : "";


export default affiliateSlice.reducer;